import React from 'react';
import { Tabs, Button } from 'antd';
import { FiArrowLeft, FiRefreshCw } from 'react-icons/fi';
import { DAG_DETAIL_TAB, DAG_DETAIL_TABS } from '../constants';
import { DagHeader } from './dag-header';
import { CodeTab } from './code-tab';
import { DetailsTab } from './details-tab';
import { OverviewTab } from './overview-tab';
import { RunsTab } from './runs-tab';
import { TasksTab } from './tasks-tab';
import { CalendarTab } from './calendar-tab';
import { TriggerDagDialog } from '../dags-tab/trigger-dag-dialog';
import { useDagDetail } from './use-dag-detail';
import styles from '../styles.module.scss';

const { TabPane } = Tabs;

/*
 * DAG detail screen — header with pause/trigger/delete actions, and its tab bar
 */
export function AirflowDagDetailScreen() {
    const {
        dagId,
        dag,
        details,
        latestRun,
        isLoadingDag,
        togglingPause,
        triggering,
        refreshKey,
        activeTab,
        handleTabChange,
        handleRefresh,
        handleTogglePause,
        handleTrigger,
        handleTriggerDialogClose,
        handleDeleteRequest,
        handleBack,
    } = useDagDetail();

    return (
        <div className={`${styles.page} airflowDashboardRoot`}>
            <div className={styles.breadcrumb}>
                <span className={styles.breadcrumbLink} onClick={handleBack}>
                    <FiArrowLeft /> All DAGs
                </span>
                <Button size="small" onClick={handleRefresh}>
                    <FiRefreshCw />
                </Button>
            </div>
            <DagHeader
                dagId={dagId}
                dag={dag}
                details={details}
                latestRun={latestRun}
                isLoadingDag={isLoadingDag}
                togglingPause={togglingPause}
                triggering={triggering}
                onTogglePause={handleTogglePause}
                onTrigger={handleTrigger}
                onDelete={handleDeleteRequest}
            />
            <Tabs activeKey={activeTab} onChange={handleTabChange}>
                {DAG_DETAIL_TABS.map((tab) => (
                    <TabPane tab={tab.label} key={tab.value}>
                        {tab.value === DAG_DETAIL_TAB.overview && <OverviewTab dagId={dagId} refreshKey={refreshKey} />}
                        {tab.value === DAG_DETAIL_TAB.runs && <RunsTab dagId={dagId} refreshKey={refreshKey} />}
                        {tab.value === DAG_DETAIL_TAB.tasks && <TasksTab dagId={dagId} refreshKey={refreshKey} />}
                        {tab.value === DAG_DETAIL_TAB.calendar && <CalendarTab dagId={dagId} refreshKey={refreshKey} />}
                        {tab.value === DAG_DETAIL_TAB.code && <CodeTab dagId={dagId} details={details} isLoadingDetails={isLoadingDag} refreshKey={refreshKey} />}
                        {tab.value === DAG_DETAIL_TAB.details && <DetailsTab dag={dag} details={details} isLoading={isLoadingDag} />}
                    </TabPane>
                ))}
            </Tabs>
            {triggering && <TriggerDagDialog dagId={dagId} onClose={handleTriggerDialogClose} />}
        </div>
    );
}
